import { Box } from '@mantine/core';
import type { TooltipProps } from 'recharts';
import { useTranslation } from 'react-i18next';
import {
  baseBlack,
  baseWhite,
  borderRadiusSmall,
  boxShadowBigSoft,
  secondaryBase,
  skyDark,
} from '../../../../../styles/design-tokens';
import { Text } from '../../../../../ui-library/typography/typography';
import { TreeMapData, TreeMapDataType } from '../main-section.type';

export const TreeMapTooltip = (props: TooltipProps<number, string>) => {
  const { active, payload } = props as any;
  if (active && payload && payload.length > 0) {
    const data = payload[0].payload;

    return (
      <Box
        style={{
          backgroundColor: baseWhite,
          padding: '8px 20px',
          borderRadius: borderRadiusSmall,
          boxShadow: boxShadowBigSoft,
        }}
        maw={300}
      >
        <TooltipTitle data={data} />
        <TooltipDescription data={data} />
      </Box>
    );
  }

  return null;
};

const TooltipTitle = ({ data }: { data: TreeMapData }) => {
  const i18n = useTranslation();
  const percentage = data.actualSize ? <span style={{ color: skyDark }}>({data.actualSize?.toFixed(2)}%)</span> : null;

  const title =
    data.type === TreeMapDataType.Initiative ? data.initiativeKey || data.name : i18n.t('strategy.initiatives.other');
  const titleColor = data.type === TreeMapDataType.Initiative ? secondaryBase : baseBlack;

  return (
    <Text size="small" color={titleColor}>
      {title} {percentage}
    </Text>
  );
};

const TooltipDescription = ({ data }: { data: TreeMapData }) => {
  const i18n = useTranslation();
  return (
    <Text size="small" weight="medium">
      {data.type === TreeMapDataType.Initiative
        ? data.initiativeName
        : i18n.t('strategy.initiatives.combined_initiatives')}
    </Text>
  );
};
